// W2 (2026-05-24) — AJ 경매 낙찰 CSV 수동 import + 통계
// admin only. 분석 보고서: docs/analysis/external-auction-prices-2026-05-24.md

import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

function StatRow(props) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #eee' }}>
      <span style={{ color: '#666' }}>{props.label}</span>
      <span style={{ fontWeight: 600 }}>{props.value}</span>
    </div>
  );
}

function fmtNum(n) {
  if (n == null) return '-';
  return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function AdminAuctionDataPage(props) {
  var showToast = props && props.showToast;
  var [file, setFile] = useState(null);
  var [dryRunResult, setDryRunResult] = useState(null);
  var [importResult, setImportResult] = useState(null);
  var [stats, setStats] = useState(null);
  var [busy, setBusy] = useState(false);

  function loadStats() {
    authFetch(API + '/admin/auction-data/stats')
      .then(function(r) { return r.json(); })
      .then(function(d) { setStats(d); })
      .catch(function() { showToast && showToast('통계 조회 실패', 'error'); });
  }

  useEffect(function() { loadStats(); }, []);

  function onFileChange(e) {
    var f = e.target.files && e.target.files[0];
    setFile(f || null);
    setDryRunResult(null);
    setImportResult(null);
  }

  function postCsv(endpoint) {
    if (!file) {
      showToast && showToast('CSV 파일을 먼저 선택하세요', 'error');
      return null;
    }
    var fd = new FormData();
    fd.append('file', file);
    setBusy(true);
    return authFetch(API + endpoint, { method: 'POST', body: fd })
      .then(function(r) { return r.json(); })
      .finally(function() { setBusy(false); });
  }

  function runDryRun() {
    var p = postCsv('/admin/auction-data/import/dry-run');
    if (!p) return;
    p.then(function(d) {
      if (d && d.success) {
        setDryRunResult(d.stats);
        showToast && showToast('미리보기 완료', 'success');
      } else {
        showToast && showToast((d && d.error) || '실패', 'error');
      }
    });
  }

  function runImport() {
    if (!dryRunResult) {
      showToast && showToast('먼저 미리보기를 실행하세요', 'error');
      return;
    }
    if (!window.confirm((dryRunResult.wouldInsert || 0) + ' 건을 적재합니다. 계속할까요?')) return;
    var p = postCsv('/admin/auction-data/import');
    if (!p) return;
    p.then(function(d) {
      if (d && d.success) {
        setImportResult(d.stats);
        loadStats();
        showToast && showToast('적재 완료: ' + (d.stats.inserted || 0) + ' 건', 'success');
      } else {
        showToast && showToast((d && d.error) || '실패', 'error');
      }
    });
  }

  return (
    <div style={{ padding: 24, maxWidth: 900 }}>
      <h2 style={{ marginTop: 0 }}>경매 시세 데이터 (AJ CSV 수동 import)</h2>
      <div style={{ color: '#666', marginBottom: 16, fontSize: 13, lineHeight: 1.6 }}>
        AJ 오토옥션 수출 낙찰 CSV (UTF-8) 를 업로드하면 시세 통계 (AUTODEX 시세) 가 갱신됩니다.<br/>
        먼저 <b>미리보기</b>로 결과를 확인하고 <b>적재 실행</b>으로 DB 에 반영하세요. 중복 row 는 자동 skip 됩니다.
      </div>

      <div style={{ border: '1px solid #ddd', borderRadius: 8, padding: 16, marginBottom: 24 }}>
        <h3 style={{ marginTop: 0, fontSize: 16 }}>1. CSV 업로드</h3>
        <input type="file" accept=".csv" onChange={onFileChange} disabled={busy} />
        {file && <div style={{ marginTop: 8, fontSize: 13, color: '#444' }}>선택: {file.name} ({Math.round(file.size / 1024)} KB)</div>}

        <div style={{ marginTop: 16, display: 'flex', gap: 8 }}>
          <button onClick={runDryRun} disabled={!file || busy} style={{ padding: '8px 16px', cursor: file && !busy ? 'pointer' : 'not-allowed' }}>
            미리보기 (dry-run)
          </button>
          <button onClick={runImport} disabled={!dryRunResult || busy} style={{ padding: '8px 16px', backgroundColor: dryRunResult ? '#1B3A5C' : '#999', color: '#fff', border: 'none', borderRadius: 4, cursor: dryRunResult && !busy ? 'pointer' : 'not-allowed' }}>
            적재 실행
          </button>
        </div>

        {dryRunResult && (
          <div style={{ marginTop: 16, padding: 12, backgroundColor: '#f7f9fc', borderRadius: 4 }}>
            <b>미리보기 결과</b>
            <StatRow label="총 row" value={fmtNum(dryRunResult.total)} />
            <StatRow label="수출+낙찰 통과" value={fmtNum(dryRunResult.wouldInsert)} />
            <StatRow label="필터 제외 (내수/유찰/사고)" value={fmtNum(dryRunResult.filtered)} />
            <StatRow label="필수 컬럼 누락" value={fmtNum(dryRunResult.invalid)} />
          </div>
        )}

        {importResult && (
          <div style={{ marginTop: 16, padding: 12, backgroundColor: '#e8f5e9', borderRadius: 4 }}>
            <b>적재 결과</b>
            <StatRow label="신규 적재" value={fmtNum(importResult.inserted)} />
            <StatRow label="중복 skip" value={fmtNum(importResult.duplicates)} />
            <StatRow label="필터 제외" value={fmtNum(importResult.filtered)} />
            <StatRow label="필수 컬럼 누락" value={fmtNum(importResult.invalid)} />
          </div>
        )}
      </div>

      <div style={{ border: '1px solid #ddd', borderRadius: 8, padding: 16 }}>
        <h3 style={{ marginTop: 0, fontSize: 16 }}>2. 누적 통계</h3>
        {stats ? (
          <div>
            <StatRow label="총 row" value={fmtNum(stats.total)} />
            {stats.bySource && stats.bySource.map(function(s) {
              return (
                <StatRow key={s.source}
                  label={'source: ' + s.source + ' (' + s.min_date + ' ~ ' + s.max_date + ')'}
                  value={fmtNum(s.count)} />
              );
            })}
            {stats.recent && stats.recent.length > 0 && (
              <div style={{ marginTop: 16 }}>
                <b>최근 10건</b>
                <table style={{ width: '100%', marginTop: 8, fontSize: 13, borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#f7f9fc', textAlign: 'left' }}>
                      <th style={{ padding: 6 }}>source</th>
                      <th style={{ padding: 6 }}>낙찰일</th>
                      <th style={{ padding: 6 }}>차종</th>
                      <th style={{ padding: 6 }}>년식</th>
                      <th style={{ padding: 6, textAlign: 'right' }}>VAT포함</th>
                      <th style={{ padding: 6, textAlign: 'right' }}>VAT제외</th>
                    </tr>
                  </thead>
                  <tbody>
                    {stats.recent.map(function(r, idx) {
                      return (
                        <tr key={idx} style={{ borderTop: '1px solid #eee' }}>
                          <td style={{ padding: 6 }}>{r.source}</td>
                          <td style={{ padding: 6 }}>{r.event_date}</td>
                          <td style={{ padding: 6 }}>{r.maker} {r.model}</td>
                          <td style={{ padding: 6 }}>{r.year}</td>
                          <td style={{ padding: 6, textAlign: 'right' }}>{fmtNum(r.winning_price_inc_vat)}만</td>
                          <td style={{ padding: 6, textAlign: 'right' }}>{fmtNum(r.winning_price_ex_vat)}만</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ) : (
          <div style={{ color: '#999' }}>로딩...</div>
        )}
      </div>
    </div>
  );
}

export default AdminAuctionDataPage;
